import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayCommonEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/common/`
        this.webApi = new WebApi()
    }

    // get offline Points
    async getOfflinePoints (clientId, tableOptions) {
        const points = await this.webApi.post(`${this.url}DashboardOfflinePoints`, { clientId: clientId, page: tableOptions.page, limit: tableOptions.itemsPerPage })
        if (points) {
            if (!points.status_code) {
                if (!points.error) {
                    return points
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${points.status_code}`)
            }
        }
        return null
    }

    // Get all points with monitoring
    async getPm (clientId) {
        const points = await this.webApi.post(`${this.url}pm`, { clientId: clientId })
        // console.log('points:', points)
        if (points) {
            if (!points.status_code) {
                if (!points.error) {
                    return points
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${points.status_code}`)
            }
        }
        return null
    }

    // Get  points with address
    async getPa (clientId, tableOptions) {
        const points = await this.webApi.post(`${this.url}pa`, { clientId: clientId, page: tableOptions.page, limit: tableOptions.itemsPerPage })
        // console.log('getPa  points:', points)
        if (points) {
            if (!points.status_code) {
                if (!points.error) {
                    return points
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${points.status_code}`)
            }
        }
        return null
    }
}
